import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostComgate_municipalityIdCreate_payment = z.any()
export type TagsPostComgate_municipalityIdCreate_payment = z.infer<typeof tagsPostComgate_municipalityIdCreate_payment>

export const bodyPostComgate_municipalityIdCreate_payment = z.object({ "refId": z.string().min(1) })
export type BodyPostComgate_municipalityIdCreate_payment = z.infer<typeof bodyPostComgate_municipalityIdCreate_payment>

export const paramsPostComgate_municipalityIdCreate_payment = z.object({ "municipalityId": z.string().uuid() })
export type ParamsPostComgate_municipalityIdCreate_payment = z.infer<typeof paramsPostComgate_municipalityIdCreate_payment>

export const responsePostComgate_municipalityIdCreate_payment = z.object({ "payload": z.object({ "code": z.string(), "message": z.string(), "transId": z.string(), "redirect": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostComgate_municipalityIdCreate_payment = z.infer<typeof responsePostComgate_municipalityIdCreate_payment>

interface IPostComgate_municipalityIdCreate_payment extends BaseMethodType {
  tags: TagsPostComgate_municipalityIdCreate_payment,
  body: BodyPostComgate_municipalityIdCreate_payment,
  params: ParamsPostComgate_municipalityIdCreate_payment,
  response: ResponsePostComgate_municipalityIdCreate_payment
}
export const URL = '/comgate/:municipalityId/create-payment'
export const validation = {
  post: {
    tags: tagsPostComgate_municipalityIdCreate_payment,
    body: bodyPostComgate_municipalityIdCreate_payment,
    params: paramsPostComgate_municipalityIdCreate_payment,
    response: responsePostComgate_municipalityIdCreate_payment
  }
}
export interface Comgate_municipalityIdCreate_payment extends BaseRouteType {
  post: IPostComgate_municipalityIdCreate_payment
}